<template>
    <section id="mobile-image-comparison" :class="{ 'move-left': imageComparisonEnabled }">
        <div @click.stop="toggleImageComparisonEnabled" class="image-comparison-button d-flex justify-content-center align-items-center">
            <icon name="ci-image-divider" color="black" scale="1.2" />
        </div>
    </section>
</template>

<script>
/**
 * Summary.
 * Mobile image comparison toggle button.
 *
 * @param {Boolean} imageComparisonEnabled
 *
 * @event imageComparisonChange
 */
export default {
    props: {
        imageComparisonEnabled: Boolean,
    },
    data() {
        return {
            comparison: false,
        }
    },
    methods: {
        toggleImageComparisonEnabled() {
            this.comparison = !this.comparison
            this.$emit('imageComparisonChange', this.comparison)
        },
    },
}
</script>

<style lang="scss" scoped>
#mobile-image-comparison.move-left {
    transition: all 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53);
    .image-comparison-button {
        background-color: var(--secondary);
        transition: all 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53);
    }
}

#mobile-image-comparison {
    position: absolute;
    top: calc(16px + 42px + 8px + 42px + 8px + 42px + 8px);
    right: 12px;
    z-index: 99;
    transition: all 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53);
    .image-comparison-button {
        cursor: pointer;
        width: 42px;
        height: 42px;
        border-radius: 50%;
        background-color: var(--primary-2);
        transition: all 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53);
    }
}
</style>
